import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Link, NavLink, matchPath, useLocation } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { Context } from '../../context/UserContext';

const Sidebar = () => {

    const context = useContext(Context);
    const roleId = localStorage.getItem('rl');
    const urlAddress = useLocation()

    const { readData: getMenus } = useEntityCrud('Privileges/getMenus');
    const { addData: addMenu } = useEntityCrud('Privileges/setMenu');
    const { readData: getPermissions } = useEntityCrud('Privileges/getPrivileges?roleId=' + roleId);



    // const sidebarMenus = roleId == 1 ? [
    //     {
    //         label: "داشبورد",
    //         link: "/",
    //         icon: "fa-qrcode"
    //     },
    //     {
    //         label: " اطلاعات پایه ",
    //         link: "/baseInfo",
    //         icon: "fe fe-info"
    //     },
    //     {
    //         label: "اطلاعیه ها",
    //         link: "/notifications",
    //         icon: "fe fe-bell"
    //     },
    //     {
    //         label: " اصناف ",
    //         link: "/guilds",
    //         icon: "lnr lnr-pie-chart"
    //     },
    //     {
    //         label: " کسب و کار ها ",
    //         link: "/organizations",
    //         icon: "fe fe-box"
    //     }, {
    //         label: "گروه",
    //         link: "/group",
    //         icon: "fe fe-server"
    //     }, {
    //         label: " سرویس  ",
    //         link: "/service",
    //         icon: "fe fe-list"
    //     }, {
    //         label: "محصول / خدمت ",
    //         link: "/subService",
    //         icon: "fe fe-file-text"
    //     }, {
    //         label: " قالب ",
    //         link: "/template",
    //         icon: "fe fe-edit-3"
    //     },/* {
    //         label: " هلدینگ ها ",
    //         link: "/holding",
    //         icon: "fe fe-layers"
    //     }, */{
    //         label: " شرکت های زیر مجموعه ",
    //         link: "/branches",
    //         icon: "fe fe-grid"
    //     }, {
    //         label: " انواع پرسنل ",
    //         link: "/personnel-types",
    //         icon: "fe fe-users"
    //     }, {
    //         label: " نقش ها ",
    //         link: "/roles",
    //         icon: "fe fe-user-check"
    //     }, {
    //         label: " پرسنل ",
    //         link: "/personnel",
    //         icon: "fe fe-user"
    //     }, {
    //         label: "  کاربران ",
    //         link: "/users",
    //         icon: "fe fe-users"
    //     }, {
    //         label: " کد های تخفیف",
    //         link: "/discounts",
    //         icon: "fe fe-percent",
    //     }
    //     , {
    //         label: " فروش ",
    //         link: "/service-consumer",
    //         icon: "fe fe-dollar-sign"
    //     }
    //     , {
    //         label: " برگشت تراکنش ",
    //         link: "/transaction-reversal",
    //         icon: "fe fe-dollar-sign"
    //     }
    //     , {
    //         label: "گزارشات",
    //         link: "/reports",
    //         icon: "lnr lnr-pie-chart"
    //     },
    //     {
    //         label: " تبلیغات ",
    //         link: "/advertiseList",
    //         icon: "fe fe-film"
    //     },
    //     {
    //         label: " نظرسنجی ",
    //         link: "/survey",
    //         icon: "fe fe-star"
    //     },
    //     {
    //         label: " معیارهای نظرسنجی ",
    //         link: "/surveyCriterias",
    //         icon: "fe fe-star"
    //     }
    //     ,
    //     {
    //         label: "وزن امتیازات نظرسنجی",
    //         link: "/surveyPoints",
    //         icon: "fe fe-star"
    //     }

    // ] : roleId == 2 ? [
    //     {
    //         label: "داشبورد",
    //         link: "/",
    //         icon: "fa-qrcode"
    //     }, {
    //         label: " شرکت های زیر مجموعه ",
    //         link: "/branches",
    //         icon: "fe fe-grid"
    //     }, {
    //         label: " انواع پرسنل ",
    //         link: "/personnel-types",
    //         icon: "fe fe-users"
    //     }, {
    //         label: " پرسنل ",
    //         link: "/personnel",
    //         icon: "fe fe-user"
    //     }, {
    //         label: " کد های تخفیف",
    //         link: "/discounts",
    //         icon: "fe fe-percent"
    //     }
    // ] : roleId == 3 ? [
    //     {
    //         label: "داشبورد",
    //         link: "/",
    //         icon: "fa-qrcode"
    //     }, {
    //         label: "گروه",
    //         link: "/group",
    //         icon: "fe fe-server"
    //     }, {
    //         label: " سرویس  ",
    //         link: "/service",
    //         icon: "fe fe-list"
    //     }, {
    //         label: "محصول / خدمت ",
    //         link: "/subService",
    //         icon: "fe fe-file-text"
    //     }, {
    //         label: " قالب ",
    //         link: "/template",
    //         icon: "fe fe-edit-3"
    //     }
    // ] : [
    //     {
    //         label: " پرسنل ",
    //         link: "/personnel",
    //         icon: "fe fe-user"
    //     },
    //     {
    //         label: " فروش ",
    //         link: "/service-consumer",
    //         icon: "fe fe-dollar-sign"
    //     }
    // ];

    const [menus, setMenus] = useState([]);
    const [menusChild, setMenusChild] = useState([]);


    useEffect(() => {
        getPermissions().then(({ data }) => {
            if (data.status && data.result.privilegesMap && data.result.privilegesMap.length > 0) {
                context.setPermissions(data.result.privilegesMap);
                getMenus().then(res => {
                    const menusList = [...res.data.result.filter(menu => data.result.privilegesMap.find(permission => permission.menuId == menu.id && permission.crudMap[`readValue`] == 1))]
                    const menus = []
                    menusList.map(menu => {
                        if(menu.title.toString().trim() == 'کسب و کار ها' && roleId == 3)
                            menus.push({
                                ...menu,
                                title: 'اطلاعات پایه فروشگاه',
                                url: `${menu.url}/update/${localStorage.getItem('businessId')}`
                            })
                        else
                            menus.push({
                                ...menu
                            })
                    })
                    setMenus(menus);
                })
            }
        });
    }, [])


    useEffect(() => {
        if (!(urlAddress.pathname.includes("Deliveries"))) {
            localStorage.removeItem("businessIdDelivery")
            localStorage.removeItem("nationalCodeDelivery")
            localStorage.removeItem("businessTitle")
        }

        if (!(urlAddress.pathname.includes("service"))) {
            localStorage.removeItem("searchDetailsBuinessID")
            localStorage.removeItem("searchDetailsGroupID")
        }

    })

     /*    const location = useLocation();
    
         useEffect(() => {
            if (!(location.pathname.includes("group"))) {
                localStorage.removeItem("searchDetails");
            }
            if (!(location.pathname.includes("service"))) {
                localStorage.removeItem("searchDetailsBuinessID");
                localStorage.removeItem("searchDetailsGroupID");
            }
            if (!(location.pathname.includes("subService"))) {
                localStorage.removeItem("buinessID");
                localStorage.removeItem("groupID");
                localStorage.removeItem("serviceID");
            }
        }, [menus]) */


    function handleToggleExpand(menuIndex) {
        const newMenus = [...menus];
        newMenus[menuIndex].expand = !newMenus[menuIndex].expand
        setMenusChild(newMenus);
    }


    return (
        <div className="sticky">
            <div className="app-sidebar__overlay" data-bs-toggle="sidebar"></div>
            <div className="app-sidebar">
                <div className="side-header">
                    <Link className="header-brand1" to="/">
                        <img src="/assets/images/brand/logo.png" className="header-brand-img desktop-logo" alt="logo" />
                        <img src="/assets/images/brand/logo-1.png" className="header-brand-img toggle-logo" alt="logo" />
                        <img src="/assets/images/brand/logo-2.png" className="header-brand-img light-logo" alt="logo" />
                        <img src="/assets/images/brand/logo-3.png" className="header-brand-img light-logo1" alt="logo" />
                    </Link>
                </div>
                <div className="main-sidemenu">
                    {/* <div className="slide-left disabled" id="slide-left"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" /></svg></div> */}
                    <ul className="side-menu">
                        {menus.map((item, index) =>

                            <li className="slide" key={index} onClick={() => localStorage.setItem('mI', item.id)}>
                                <div className="side-menu__item d-block" data-bs-toggle="slide" >
                                    {item.url ?
                                        <>
                                            {item.parentId === 0 && <NavLink exact className="side-menu__item" to={item.url}
                                                activeClassName={"active"}> <i
                                                    className={`fa  px-1 ${item.icon}`}></i>
                                                <span className="side-menu__label px-1"> {item.title} </span>
                                            </NavLink>}
                                        </>

                                        : <span onClick={() => handleToggleExpand(index)} className="side-menu__item dFlexMenu_">
                                            <span >
                                                <i className={`fa  px-1 ${item.icon}`}></i>
                                                {item.title}</span>
                                            <i className={`fa ${item.expand ? "fa-chevron-down" : "fa-chevron-up"}`} style={{ fontSize: "11px" }}></i>
                                        </span>
                                    }
                                    {item.expand && <ul className="list-style-type" style={{ marginRight: "25%", listStyle: "arabic-indic" }}>
                                        {menusChild.filter(i => i.parentId === item.id).map(item =>
                                            <li>
                                                <NavLink exact className="side-menu__item child_" to={item.url}
                                                    activeClassName={"active"}>{item.title}</NavLink>
                                            </li>
                                        )}

                                    </ul>}
                                </div>
                            </li>

                        )

                        }

                    </ul>
                    {/* <div className="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" /></svg></div> */}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;